import * as React from "react";
import '../../../styles/style.css';
import useFetch from '../../api/useFetch';
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem } from "@progress/kendo-react-charts";
import { color } from "echarts";

const GraficaEmpleados = () => {
  const fetchResult = useFetch("api/Empleados/EventyFijos");
  const empleados = fetchResult.data ?? [];
  const isLoading = fetchResult.isLoading;

  const chartData =
    Array.isArray(empleados) && empleados.length > 0
      ? [
          { type: "Fijos", value: empleados[0]?.fijos ?? 0,color:'#58b920ff' },
          { type: "Eventuales", value: empleados[0]?.eventuales ?? 0,color:'#105510ff'},
        ]
      : [];
    
  if (isLoading) return <div>Cargando gráfica...</div>;

  return (
    <div className="grafica-container">
       <Chart style={{ height: "100%",background: "transparent" }}>
      <ChartSeries>
        <ChartSeriesItem
          type="donut"
          data={chartData}
          categoryField="type"
          field="value"
          labels={{
            visible: true,
            background: "none",
            color: "#fffbfbff",
            content: (e) => `${e.value}`
        }}
        />
      </ChartSeries>
      <ChartLegend position="bottom" visible={true} />
    </Chart>
    
    </div>
         
  );
};

export default GraficaEmpleados;
